export default __webpack_public_path__ + "static/media/logo.935c828c.png";